import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import ParticlesAuth from "../ParticlesAuth";

// Import Images
import error from "../../../assets/images/error.svg";
import UiContent from '../../../Components/Common/UiContent';

const Basic404 = () => {

    return (

        <React.Fragment>
            <UiContent />
            <div className="page-content mb-10">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center pt-4">
                                <div className="">
                                    <img src={error} alt="" style={{ height: '20em' }} className="error-basic-img move-animation" />
                                </div>
                                <div className="mt-n4">
                                    <h1 className="display-1 fw-semibold">404</h1>
                                    <h3 className="text-uppercase">Lo siento, página no encontrada</h3>
                                    <p className="text-muted mb-4">¡La página que estás buscando no está disponible!</p>
                                    <Link to="/dashboard" className="btn btn-success"><i className="mdi mdi-home me-1"></i>Volver al inicio</Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
};

export default Basic404;